import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { path } from 'ramda';

import { ANIMATION_DELAY } from './constants.buzz.js';
import { useAppSelector } from '@core/js/store/hooks';
import { useGetPageRoutingURL } from 'js/hooks/useGetPageRoutingURL';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';
import {
    isHashLink,
    getPartsUrl,
    getCleanUrl,
    isExternalUrl,
    getCombinedSearch,
    isDocumentsAndMediaUrl,
    getPathWithTrailingSlash
} from 'js/utils/url.util';

import style from 'js/components/common/Link/Link.scss';

export const Link = ({
    children, href = '', className = '', isDefaultLinkClass = true, inNewWindow = false, isScrollTop = true, onClick = () => {}, ...other
}) => {
    const location = useLocation();
    const linkPath = useGetPageRoutingURL(href);
    const isDocAndMediaUrl = isDocumentsAndMediaUrl(href);
    const isRegularLink = isExternalUrl(linkPath) || isHashLink(linkPath) || isDocAndMediaUrl;
    const isPageInPopupUrl = useIsPageInPopupUrl();
    const useTrailingSlash = useAppSelector(path(['seo', 'useTrailingSlash']));

    const handleOnClick = (event) => {
        onClick(event);

        if (!isRegularLink && isScrollTop && !isPageInPopupUrl(linkPath)) {
            setTimeout(() => {
                window.scrollTo({ top: 0 });
            }, ANIMATION_DELAY);
        }
    };
    const attribs = {
        href,
        className: `${isDefaultLinkClass ? style.link : ''} ${className}`,
        target: inNewWindow ? '_blank' : '_self',
        onClick: handleOnClick,
        ...other
    };

    if (isDocAndMediaUrl) {
        const [, , , formattedPath] = getPartsUrl(href);

        attribs.href = getCleanUrl(formattedPath);
    }

    if (isRegularLink) {
        return <a {...attribs}>{children}</a>;
    }

    const link = new window.URL(linkPath, document.baseURI);
    const to = {
        state: {
            prevPath: location.pathname
        },
        pathname: getPathWithTrailingSlash(link.pathname, useTrailingSlash),
        search: getCombinedSearch(link.search, location.search),
        hash: link.hash
    };

    return <RouterLink to={to} {...attribs}>{children}</RouterLink>;
};
